import React, { Component } from 'react'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tooltip } from 'primereact/tooltip';
import { Toast } from 'primereact/toast';
import Service from '../../../services';
import { Menu } from 'primereact/menu';
import { InputText } from 'primereact/inputtext';
import { FilterMatchMode } from 'primereact/api';
import Authorizer, { PERMISSIONS } from '../../../session/authorizer';
import { BasicLazyParams } from '../../../../utile';
import { baseUrlAdmin } from '../../../../store/apiConstants';
import { Checkbox } from 'primereact/checkbox';
import AssignDiagnosticTestToContent from './assignDignoseTestToChapter';
import LoadingComponent from '../../../loadingComponent';
import { AssignIcon, EditIcon } from '../../../svgIcons';
import { Dialog } from 'primereact/dialog';
import { confirmDialog, ConfirmDialog } from 'primereact/confirmdialog';
import SubjectiveUpload from './offlineExamResultUpload/subjectiveUpload';
import OfflineResultUpload from './offlineExamResultUpload/offlineResultUpload';
import AssignExamToSection from './assignExamToSection';
import axios from 'axios';
import UploadKeyDialog from './offlineExamResultUpload/UploadKeyDialog';

export default class OfflineTestList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            exams: [],
            columns: [
                { columnName: 'Total Questions', isVisible: true, id: 'totalQuestions' },
                { columnName: 'Total Marks', isVisible: true, id: 'totalMarks' }
            ],
            showSearch: false,
            globalFilter: null,
            globalSearch: '',
            globalFilterValue: '',
            filters: {
                'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
            },
            // lazyParams: BasicLazyParams,
            lazyParams: {
                ...BasicLazyParams,
                rows: 100
            },
            showUploadResult: false,
            rowDetailsOfUploading: {},
            showUploadKey: false,
            examForKeyUpload: null,
        }
        this.service = new Service();
    }

    onGlobalSearch = (e) => {
        this.setState((prevState) => {
            return {
                globalSearch: e.target.value,
                lazyParams: BasicLazyParams
            }
        }, this.onSearch);
    }

    onPage = (event) => {
        this.setState((prevState) => {
            return {
                lazyParams: {
                    ...prevState.lazyParams,
                    ...event
                }
            };
        }, this.onSearch);
    }

    onSort = (event) => {
        this.setState((prevState) => {
            return {
                lazyParams: {
                    ...prevState.lazyParams,
                    ...event
                }
            };
        }, this.onSearch);
    }

    onFilter = (event) => {
        event['first'] = 0;
        this.setState((prevState) => {
            return {
                lazyParams: {
                    ...prevState.lazyParams,
                    filters: event.filters
                }
            };
        }, this.onSearch);
    }

    onColumnClick = (column) => {
        let columns = this.state.columns.map(c => {
            if (column.id == c.id) {
                c.isVisible = !c.isVisible;
            }
            return c;
        });
        this.setState({
            columns
        });
    }

    isColumnVisible = (id) => {
        return this.state.columns.filter(c => c.id == id)[0].isVisible;
    }

    exportCSV = () => {
        this.dt.exportCSV();
    }

    onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let filters = { ...this.state.filters };
        filters['global'].value = value;
        this.setState({ filters, globalFilterValue: value });
    }

    componentDidMount() {
        this.onSearch();
    }

    onSearch = () => {
        const {
            lazyParams, globalSearch
        } = this.state;

        let filters = { examType: 'OfflineTest' };

        this.setState({
            isLoading: true,
            questions: [],
            totalRecords: 0
        });

        this.service.post(`${baseUrlAdmin}/examination/filter?limit=${lazyParams.rows}&page=${lazyParams.page + 1}&search=${globalSearch}&examType=${'OfflineTest'}&academicYear=${localStorage.getItem('userAcademicYear') || ''}${lazyParams.sortField ? `&sort=${lazyParams.sortOrder == 1 ? '' : '-'}${lazyParams.sortField}` : ''}`, filters, true).then((data) => {
            if (data && data.status && data?.res?.data) {
                this.setState({
                    totalRecords: data.res.data.totalRecords,
                    exams: data.res.data.exams,
                    isLoading: false
                })
            } else {
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'No Exams', detail: "No Exams Found", life: 3000 });
            }
        }).catch(e => {
            this.setState({
                isLoading: false
            })
            this.toast.show({ severity: 'error', summary: 'Some error occured', detail: e.message, life: 3000 });
            console.log(e);
        });
    }

    assignExam = (examToAssign) => {
        this.setState({
            isShowAssignDialog: true,
            examToAssign
        })
    }

    onAssignSuccess = () => {
        this.setState({
            isShowAssignDialog: false
        })

        this.toast.show({ severity: 'success', summary: 'Modified', detail: 'Successfully assigned offline test', life: 6000 });
    }

    onClickUploadExamReports = (rowData) => {
        this.setState({
            showUploadResult: true,
            rowDetailsOfUploading: rowData
        })
    }

    onUploadKey = (rowData) => {
        this.setState({ showUploadKey: true, examForKeyUpload: rowData });
    }

    handleDownload = (url, filename) => {
        axios.get(url, {
            responseType: 'blob',
        })
            .then((res) => {
                const url = window.URL.createObjectURL(
                    new Blob([res.data]),
                );
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute(
                    'download',
                    filename,
                );

                // Append to html link element page
                document.body.appendChild(link);

                // Start download
                link.click();

                // Clean up and remove the link
                link.parentNode.removeChild(link);
            })
    }

    genAndDownloadReport = (rowData) => {
        this.setState({
            isLoading: true
        });

        let url = `${baseUrlAdmin}/longrunning/${rowData.examId}/download-reports`;

        axios.get(url, {
            headers: {
                'Access-Control-Allow-Origin': '*',
            }
        })
            .then((res) => {
                if (res?.data?.data?.paperLink) {
                    this.handleDownload(
                        `https://${process.env.REACT_APP_OFFLINE_CONTENT_BUCKET || 'classetofflinecontent-old'}.s3.ap-south-1.amazonaws.com/` + res.data.data.paperLink,
                        res.data.data.paperLink
                    );
                    this.setState({
                        isLoading: false
                    });
                    this.toast.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Report downloaded successfully',
                        life: 3000
                    });
                } else {
                    throw new Error(res.data?.message || 'Failed to generate report');
                }
            })
            .catch(error => {
                console.error('Report download error:', error);
                this.setState({
                    isLoading: false
                });

                // Handle 400 status code specifically
                if (error.response?.status === 400) {
                    this.toast.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'No students have attempted this exam yet',
                        life: 3000
                    });
                } else {
                    // Handle other errors
                    const errorMessage = error.response?.data?.message || error.message || 'Failed to download report';
                    this.toast.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: errorMessage,
                        life: 3000
                    });
                }
            });
    }

    onDownloadExamReports = (rowData) => {
        this.genAndDownloadReport(rowData);
    }

    handleNotifyParents = (rowData) => {
        confirmDialog({
            message: `Send result notifications for "${rowData.examName}" to parents via configured channels?`,
            header: 'Notify Parents',
            icon: 'pi pi-send',
            acceptClassName: 'p-button-primary',
            rejectClassName: 'p-button-outlined',
            accept: async () => {
                try {
                    this.setState({ isLoading: true });

                    const response = await this.service.post(
                        `${baseUrlAdmin}/notification-workflows/exam-result/send`,
                        {
                            examId: rowData.examId,
                            examType: 'objective'
                        },
                        true
                    );

                    if (response && response.status) {
                        this.toast.show({
                            severity: 'success',
                            summary: 'Success',
                            detail: `Notifications sent to ${response.res?.data?.totalStudents || 0} students`,
                            life: 3000
                        });
                    } else {
                        this.toast.show({
                            severity: 'error',
                            summary: 'Error',
                            detail: response?.message || 'Failed to send notifications',
                            life: 3000
                        });
                    }
                } catch (error) {
                    console.error('Error sending notifications:', error);
                    this.toast.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to send notifications',
                        life: 3000
                    });
                } finally {
                    this.setState({ isLoading: false });
                }
            }
        });
    }

    render() {
        const { exams } = this.state;
        const header = (
            <div className="flex justify-content-between bg-white">
                <div className="flex">
                    <h4 className=''>Offline Test List</h4>
                    {this.state.showSearch && <InputText placeholder="Search" value={this.state.globalSearch} className="ml-4  h-2rem w-15rem" onChange={this.onGlobalSearch} />}
                </div>

                <div className="bg-blue-50 cursor-pointer mb-2 border-round">
                    <ul className="flex gap-5 mr-6">
                        <i data-pr-tooltip="Search" data-pr-position="bottom" className="pi pi-search ma-tbl-icon ma-tbl-srch" onClick={(e) => { this.setState({ showSearch: !this.state.showSearch }) }}></i>
                        <Tooltip className="table-li-tooltip" autoHide={false} target=".ma-tbl-srch" />

                        <i onClick={(event) => this.menu.toggle(event)} data-pr-tooltip="View Columns" data-pr-position="bottom" className="pi pi-sort-alt ma-tbl-icon ma-tbl-sort"></i>
                        <Tooltip className="table-li-tooltip" target=".ma-tbl-sort" />

                        <i data-pr-tooltip="Download" data-pr-position="bottom" className="pi pi-download ma-tbl-icon ma-tbl-dwnld" onClick={this.exportCSV}></i>
                        <Tooltip className="table-li-tooltip" target=".ma-tbl-dwnld" />
                    </ul>
                </div>
                <Menu
                    className=''
                    model={[
                        {
                            template: (<div className='ml-2 p-2'>
                                <h4 className="">View Columns</h4>
                                <ul>
                                    {this.state.columns.map((column) => {
                                        return <li key={column.id} onClick={() => this.onColumnClick(column)}><Checkbox inputId={column.id}
                                            checked={column.isVisible} className='mt-2'
                                        ></Checkbox>
                                            <label htmlFor={column.id} className="ml-2">{column.columnName}</label>
                                        </li>
                                    })}
                                </ul>
                            </div>)
                        }]
                    }
                    popup
                    ref={el => this.menu = el} />
            </div>
        );

        return (<>
            <Toast ref={(el) => this.toast = el} position="bottom-right" />
            <ConfirmDialog />
            <div className="card datatable-crud-demo ma-mt20">
                {/* Search Input */}
                <div className="flex justify-content-start">
                    <span className="p-input-icon-left">
                        <i className="pi pi-search" />
                        <InputText
                            value={this.state.globalFilterValue}
                            onChange={this.onGlobalFilterChange}
                            placeholder="Keyword Search"
                        />
                    </span>
                </div>
                <DataTable ref={(el) => this.dt = el}
                    className="dataTableValuesText"
                    responsiveLayout="scroll"
                    dataKey="_id"
                    value={this.state.exams}
                    filters={this.state.filters}
                    paginator showGridlines
                    rows={this.state.lazyParams.rows}
                    rowsPerPageOptions={[5, 10, 25, 50, 100]}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} tests"
                    globalFilterFields={['examName', 'boardName', 'className']}
                >
                    <Column
                        field="examName"
                        header="Exam Name"
                        sortable
                        style={{ width: "15rem", height: "6rem" }}
                        alignHeader={"center"}
                        headerClassName="text-color-secondary"
                        bodyClassName="text-center"
                    />
                    <Column
                        field="boardName"
                        header="Board Name"
                        sortable
                        style={{ width: "15rem", height: "6rem" }}
                        alignHeader={"center"}
                        headerClassName="text-color-secondary"
                        bodyClassName="text-center"
                    />
                    <Column
                        field="className"
                        header="Class Name"
                        sortable
                        style={{ width: "15rem", height: "6rem" }}
                        alignHeader={"center"}
                        headerClassName="text-color-secondary"
                        bodyClassName="text-center"
                    />
                    {this.isColumnVisible('totalQuestions') && (
                        <Column
                            field="totalNoOfQuestions"
                            header="Total Questions"
                            sortable
                            style={{ width: "15rem", height: "6rem" }}
                            alignHeader={"center"}
                            headerClassName="text-color-secondary"
                            bodyClassName="text-center"
                        />
                    )}
                    {this.isColumnVisible('totalMarks') && (
                        <Column
                            field="totalMarks"
                            header="Total Marks"
                            sortable
                            style={{ width: "15rem", height: "6rem" }}
                            alignHeader={"center"}
                            headerClassName="text-color-secondary"
                            bodyClassName="text-center"
                        />
                    )}
                    <Column
                        header="Actions"
                        alignHeader={"center"}
                        headerClassName="text-color-secondary"
                        style={{ width: "15rem", height: "6rem" }}
                        body={(rowData, { rowIndex }) => {
                            return (
                                <div className="flex justify-content-center align-items-center">
                                    {/* Edit Test */}
                                    <span data-pr-tooltip="Edit Test" data-pr-position="bottom" className={`edit-${rowIndex} ma-mr20`} onClick={() => { this.props.onEditExam(rowData.examId, 'OfflineTest') }}>
                                        <EditIcon width={20} height={20} />
                                    </span>
                                    <Tooltip className="table-li-tooltip2" autoHide={false} target={`.edit-${rowIndex}`} />

                                    {/* Clone Test */}
                                    <span data-pr-tooltip="Clone Test" data-pr-position="bottom" className={`clone-${rowIndex} ma-mr20 ml-3`} onClick={() => { this.props.onCloneExam(rowData.examId, 'OfflineTest') }}>
                                        <i className='pi pi-copy' style={{ fontSize: '20px', color: "#000" }}></i>
                                    </span>
                                    <Tooltip className="table-li-tooltip2" autoHide={false} target={`.clone-${rowIndex}`} />

                                    {/* Assign Test */}
                                    <span data-pr-tooltip="Assign Test" data-pr-position="bottom" className={`assign-${rowIndex} ml-3`} onClick={() => { this.assignExam(rowData) }}>
                                        <AssignIcon width={20} height={20} />
                                    </span>
                                    <Tooltip className="table-li-tooltip2" autoHide={false} target={`.assign-${rowIndex}`} />

                                    {/* Upload Key */}
                                    <span data-pr-tooltip="Upload Key" data-pr-position="bottom" className={`key-${rowIndex} ml-3`} onClick={() => { this.onUploadKey(rowData) }}>
                                        <i className='pi pi-key' style={{ fontSize: '20px' }} />
                                    </span>
                                    <Tooltip className="table-li-tooltip2" autoHide={false} target={`.key-${rowIndex}`} />

                                    {/* Upload Exam Results */}
                                    <span data-pr-tooltip="Upload Exam Results" data-pr-position="bottom" className={`upload-${rowIndex} ml-3`} onClick={() => { this.onClickUploadExamReports(rowData) }}>
                                        <i className='pi pi-cloud-upload' style={{ fontSize: '20px' }} />
                                    </span>
                                    <Tooltip className="table-li-tooltip2" autoHide={false} target={`.upload-${rowIndex}`} />

                                    {/* Download Exam Reports */}
                                    <span data-pr-tooltip="Download Exam Reports" data-pr-position="bottom" className={`download-${rowIndex} ml-3`} onClick={() => { this.onDownloadExamReports(rowData) }}>
                                        <i className='pi pi-download' style={{ fontSize: '20px' }} />
                                    </span>
                                    <Tooltip className="table-li-tooltip2" autoHide={false} target={`.download-${rowIndex}`} />

                                    {/* Notify Parents */}
                                    <span data-pr-tooltip="Notify Parents about Results" data-pr-position="bottom" className={`notify-${rowIndex} ml-3`} onClick={() => { this.handleNotifyParents(rowData) }}>
                                        <i className='pi pi-send' style={{ fontSize: '20px' }} />
                                    </span>
                                    <Tooltip className="table-li-tooltip2" autoHide={false} target={`.notify-${rowIndex}`} />
                                </div>
                            );
                        }}
                    />
                </DataTable>
                <Toast ref={(el) => this.toast = el} position="bottom-right" />
            </div>

            <Dialog
                header={"Upload Offline Exam Results"}
                draggable={false}
                closeOnEscape={false}
                className='ma-alert-box'
                blockScroll={true}
                dismissableMask={false}
                closable={true}
                visible={this.state.showUploadResult}
                style={{ width: '50%', height: '50vh' }}
                onHide={() => this.setState({ showUploadResult: false, rowDetailsOfUploading: {} })}
            >
                <OfflineResultUpload
                    rowDetailsOfUploading={this.state.rowDetailsOfUploading}
                    onCancel={() => {
                        this.setState({ showUploadResult: false, rowDetailsOfUploading: {} })
                    }}
                />
            </Dialog>

            {this.state.isShowAssignDialog && (
                <AssignExamToSection
                    examType="OfflineTest"
                    onAssignSuccess={this.onAssignSuccess}
                    examToAssign={this.state.examToAssign}
                    onClose={() => {
                        this.setState({
                            isShowAssignDialog: false
                        })
                    }}
                />
            )}

            {this.state.isLoading && <LoadingComponent />}

            <UploadKeyDialog
                visible={this.state.showUploadKey}
                onHide={() => this.setState({ showUploadKey: false, examForKeyUpload: null })}
                exam={this.state.examForKeyUpload}
                onSuccess={this.onSearch}
            />
        </>)
    }
}
